// API hooks for the new budget flows API
import {destroy, mutate, query, update} from "../../defaults/fetch";

export const useCreateBudgetFlow = () => {
    const createBudgetFlow = async (body) => {
        const url = `budget/flows/create`;
        const { data } = await mutate(url, true, body);
        return data;
    };
    return createBudgetFlow;
};

export const useUpdateBudgetFlow = () => {
    const updateBudgetFlow = async (body) => {
        const url = `budget/flows/update`;
        const { data } = await update(url, body);
        return data;
    };
    return updateBudgetFlow;
};

export const useDeleteBudgetFlow = () => {
    const deleteBudgetFlow = async (id) => {
        const url = `budget/flows/delete/${id}`;
        const { data } = await destroy(url);
        return data;
    };
    return deleteBudgetFlow;
};

export const useGetFlowsByAccount = () => {
    const getFlowsByAccount = async (accountId) => {
        const url = `budget/flows/by-account/${accountId}`;
        const { data } = await query(url);
        return data;
    };
    return getFlowsByAccount;
};

export const useGetAllFlows = () => {
    const getAllFlows = async (filters = {}) => {
        const url = `budget/flows/all`;
        const { data } = await query(url, filters);
        return data;
    };
    return getAllFlows;
};
